import { Box, Skeleton, VStack, StackProps } from '@chakra-ui/react'
import React, { useCallback } from 'react'
import { useColor } from '../../theme'
import { TILE_BORDER_RADIUS, TILE_HEIGHT, DEFAULT_TILE_WIDTH } from './Tile'

const TileSkeleton: React.FC<
  Omit<StackProps, 'align' | 'spacing'> & { isExtended?: boolean }
> = ({ isExtended = false, ...props }) => {
  const extendedSkeletonStartColor = useColor({
    nuance: 2,
    palette: 'secondary',
  })
  const extendedSkeletonEndColor = useColor({
    nuance: 0,
    palette: 'secondary',
  })
  const mainSkeletonStartColor = useColor({
    nuance: 3,
    palette: 'secondary',
  })
  const mainSkeletonEndColor = useColor({
    nuance: 1,
    palette: 'secondary',
  })

  const extendedSkeletonWidth = useCallback(
    (difference: number) => `calc(${DEFAULT_TILE_WIDTH} - ${difference}rem)`,
    [],
  )

  return (
    <VStack
      align="start"
      paddingBottom={isExtended ? '0.9rem' : 0}
      spacing="0.6rem"
      {...props}>
      <Skeleton
        borderRadius={TILE_BORDER_RADIUS}
        data-testid="tile-skeleton-main"
        endColor={mainSkeletonEndColor}
        height={TILE_HEIGHT}
        startColor={mainSkeletonStartColor}
        width={DEFAULT_TILE_WIDTH}
      />
      {isExtended && (
        <Box paddingLeft="0.5rem">
          {[3, 5].map((difference) => (
            <Skeleton
              borderRadius="md"
              data-testid={`tile-skeleton-extended-${difference}`}
              endColor={extendedSkeletonEndColor}
              height="0.6rem"
              key={difference}
              marginTop="0.3rem"
              startColor={extendedSkeletonStartColor}
              width={extendedSkeletonWidth(difference)}
            />
          ))}
        </Box>
      )}
    </VStack>
  )
}

export { TileSkeleton }
